import React from "react";

/** "The Exchange Alliance" in polished, animated metal (index.css .tea-gold-live / .tea-teal-live).
 *  variant "gold" = all gold (top headers); "tri" = gold THE · glossy teal EXCHANGE · gold ALLIANCE. */
export const TeaWordmark = ({ text = "The Exchange Alliance", variant = "gold", small = false, stackMobile = false, className = "", testid = "tea-wordmark" }) => {
  const base = `tea-gold-live ${small ? "tea-gold-live-sm" : ""}`;
  if (variant !== "tri") return <span data-testid={testid} className={`${base} ${className}`}>{text}</span>;
  const [first, mid, ...rest] = text.split(" ");
  return (
    <span data-testid={testid} className={className}>
      <span className={base}>{first}</span>{" "}
      <span className={`${base} tea-teal-live`}>{mid}</span>{stackMobile ? <><br className="sm:hidden" /><span className="hidden sm:inline"> </span></> : " "}
      <span className={base}>{rest.join(" ")}</span>
    </span>
  );
};
